import { render, staticRenderFns } from "./VisualAcuity.vue?vue&type=template&id=70622fe8&scoped=true&"
import script from "./VisualAcuity.vue?vue&type=script&lang=js&"
export * from "./VisualAcuity.vue?vue&type=script&lang=js&"
import style0 from "./VisualAcuity.vue?vue&type=style&index=0&id=70622fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70622fe8",
  null
  
)

export default component.exports